import { ReactNode } from "react";
import { Section } from "../Section";
import { SectionHeader } from "../SectionHeader";

type RegionProps = {
  title: string;
  belowHeaderSlot?: ReactNode;
  contentSlot: ReactNode;
};

/** Renders one of the app's four main regions */
export const Region = ({
  title,
  belowHeaderSlot,
  contentSlot,
}: RegionProps) => {
  return (
    <Section ariaLabel={title}>
      <SectionHeader heading={title} />
      {belowHeaderSlot}
      <div className="grid grid-wrap collapsed-gutters login-data-table_row">
        {contentSlot}
      </div>
    </Section>
  );
};
